// 员工学习
export const employeeLearnRouter = [
  // 套餐设置
  {
    path: '/employeeLearn/packageSet',
    name: 'packageSet',
    component: () => import('../views/employeeLearn/packageSet')
  },
  // 订单管理
  {
    path: '/employeeLearn/orderMng',
    name: 'orderMng',
    component: () => import('../views/employeeLearn/orderMng')
  },
  // 客户数据
  // 客户数据-套餐数据
  {
    path: '/employeeLearn/packageData',
    name: 'packageData',
    component: () => import('../views/employeeLearn/packageData')
  },
  // 客户数据-课程数据
  {
    path: '/employeeLearn/courseData',
    name: 'courseData',
    component: () => import('../views/employeeLearn/courseData')
  },
  // 客户数据-课程数据--详情
  {
    path: '/employeeLearn/courseDataDetails',
    name: 'courseDataDetails',
    component: () => import('../views/employeeLearn/courseDataDetails')
  },
  // 课程统计
  {
    path: '/employeeLearn/courseStatistics',
    name: 'courseStatistics',
    component: () => import('../views/employeeLearn/courseStatistics')
  },
  // 课程管理
  // 供应商课程
  {
    path: '/employeeLearn/supplierCourses',
    name: 'supplierCourses',
    component: () => import('../views/employeeLearn/supplierCourses')
  },
  // 供应商课程--详情
  {
    path: '/employeeLearn/supplierCoursesDetails',
    name: 'supplierCoursesDetails',
    component: () => import('../views/employeeLearn/supplierCoursesDetails')
  },
  // 课程分类
  {
    path: '/employeeLearn/courseClassification',
    name: 'supplierCourses',
    component: () => import('../views/employeeLearn/courseClassification')
  },
  // 已选中课程
  {
    path: '/employeeLearn/selectedCourses',
    name: 'supplierCourses',
    component: () => import('../views/employeeLearn/selectedCourses')
  },
  // 已选中课程--详情
  {
    path: '/employeeLearn/selectedCoursesDetails',
    name: 'supplierCourses',
    component: () => import('../views/employeeLearn/selectedCoursesDetails')
  },
  // 热门推荐
  {
    path: '/employeeLearn/hotRecommend',
    name: 'hotRecommend',
    component: () => import('../views/employeeLearn/hotRecommend')
  },
]